import React from 'react';
import './style.css';
import Auth from '../../services/api/Auth'

class Loading extends React.Component {

    timeout = null

    constructor(props) {
      super(props);
      this.state = { show_reload : false}
    }

    componentDidMount = () => {
      this.timeout = setTimeout(() => {
        this.setState({
          show_reload: true
        })
      }, 10000)
    }
    componentWillUnmount = () => {
      clearTimeout(this.timeout )
    }
    reloadPage = e => {
        // HTP
        window.location.reload()
    }
    logout = e => {
        Auth.logOut()
        window.location.href = '/'
    }
    render() {
        return (
          <div className="loading_wrapper">
              <div className="spinner">
                  <div className="double-bounce1"></div>
                  <div className="double-bounce2"></div>
              </div>
              { this.state.show_reload && <div className="reload_button">
                 <a className="cursor_pointer button reload_btn " onClick={this.reloadPage}  >Oldal újratöltése</a>
                 <a className="cursor_pointer button  " onClick={this.logout} style={{"marginTop": "20px"}}  >Kilépés</a>
              </div>
              }
          </div>
        )
    }
}
export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js